export const classNameBuilder = (
  ...classNames: (string | boolean | undefined)[]
): string =>
  classNames
    .filter(className => className)
    .join(' ')
    .replace(/\s\s+/g, ' ')
    .trim()
